"use client";
import * as React from 'react';
import { wrapper } from './styles.js';

/**
 * @deprecated -- Please do not use this component. It is deprecated and will be removed in the future is no longer receiving updates.
 */
var LogoWidget = function LogoWidget(_ref) {
  var _ref$highlightColor = _ref.highlightColor,
    highlightColor = _ref$highlightColor === undefined ? 'inherit' : _ref$highlightColor,
    _ref$href = _ref.href,
    href = _ref$href === undefined ? 'https://www.fortum.fi' : _ref$href,
    _ref$title = _ref.title,
    title = _ref$title === undefined ? 'Fortum Etusivu' : _ref$title;
  return /*#__PURE__*/React.createElement(wrapper, {
    "data-testid": "elemental-LogoWidget",
    $highlightColor: highlightColor,
    href: href
  }, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 825 350",
    "aria-labelledby": "elemental-Header-logo-title",
    role: "img"
  }, /*#__PURE__*/React.createElement("title", {
    id: "elemental-Header-logo-title"
  }, title), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M151.5,192c11,19.1,37.1,27.3,57.9,15.2c21-12.1,26.8-38.7,15.8-57.8c-11-19.1-36.9-27.4-57.9-15.2\tC146.4,146.2,140.5,172.9,151.5,192z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M146.4,194.9c-12.6-21.7-5.8-52.1,18-65.8l5.1-19l-19-5.1l0,0l0,0c-36.3,20.9-48.7,67.3-27.8,103.6\tc20.9,36.3,67.4,48.7,103.6,27.7l-13.9-24.1C188.6,226,158.9,216.7,146.4,194.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M293.4,130.5c-7.5,0-12.2,5.2-12.2,13.5v13.3h17.1v18.6h-17.1v62.9h-23.3v-62.9h-10.8v-18.6h10.8v-11.2 c0-17.2,3.5-36.1,30.7-36.1c6.5,0,9.6,0.7,15.9,2v20C301.5,131.3,298.9,130.5,293.4,130.5 M714,238.8v-47.2c0-13.6-1-20.1-3.9-25.1 c-4.1-7.2-12.8-11.7-22.8-11.7c-12.2,0-20.6,6-26.3,19.1c-2.9-12.7-10.1-19.1-22.1-19.1c-12.4,0-19.8,5.8-26,18.5v-16.8h-22.6v82.2 h23.4v-38.2c0-5.3,0.3-9.3,1.2-12.2c2.1-7.4,7.3-12.2,13.6-12.2c4.8,0,8.3,2.4,10,6.7c1.2,3.1,1.7,7.2,1.7,14.8v41.1h23.6v-39.6 c0-14.9,5-23,14.8-23c5.7,0,9.5,2.5,10.9,8c0.5,2.4,0.9,6.9,0.9,12.2v42.3H714z M581.4,198.8v-42.2h-23.4v42.2 c0,16.5-3.1,22-13.6,22c-10.8,0-14.5-5.5-14.5-20.6v-43.6h-23.4v43.3c0,18,2.9,25.9,11.1,32.8c6.5,5.3,15.8,8.1,26.6,8.1 c12.7,0,23-4.1,29.5-11.7C579,222.8,581.4,214.4,581.4,198.8 M498.7,238.8v-18.4c-3.8,0.9-6.2,1-9.6,1c-10.5,0-13.8-3.9-13.8-15.6 v-29.9h22.4v-18.7h-22.4v-26.9l-23.4,13.2v66.4c0,21.1,9.7,30.4,31.4,30.4C488.8,240.3,492.9,240,498.7,238.8 M444.3,179.1 c-4.1-1.9-6.7-2.4-10.8-2.4c-13,0-20.5,9.8-20.5,25.6v36.5h-23.4v-82.2h22.6v18.7c2.9-12.5,11.8-19.9,24.8-19.9 c2.2,0,4.5,0.3,7.4,0.9V179.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "currentColor",
    d: "M381.3,197.5c0-25.2-14.8-43.3-40.4-43.3 c-24.4,0-40.7,18.5-40.7,42.9c0,26.8,16,43.8,41.2,43.8C364.8,241,381.3,223,381.3,197.5L381.3,197.5z M357.7,197.4 c0,14.6-6.1,23.6-16.4,23.6c-10.6,0-17.5-9.6-17.5-23.8c0-14.1,6.6-23.3,17.1-23.3C351.4,173.9,357.7,182.8,357.7,197.4 L357.7,197.4z"
  })));
};

export { LogoWidget };
